import { Card } from "../../Card";
import { Organization } from "../../../shared/types";

interface AdminHeaderProps {
  title: string;
  description: string;
  organization: Organization;
}

const AdminHeader = ({ title, description, organization }: AdminHeaderProps) => {
  return (
    <Card className="p-8 mb-6">
      <div className="text-center space-y-4">
        <h1 className="text-3xl font-bold text-gray-800">{title}</h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          {description}
        </p>
        <div className="flex items-center justify-center gap-4">
          <div className="bg-yellow-400 text-gray-700 px-3 py-1 rounded-full text-sm font-semibold">
            Admin Only
          </div>
          <div className="bg-gray-200 text-gray-700 px-3 py-1 rounded-full text-sm font-semibold">
            Organization: {organization.name}
          </div>
          <div className="bg-gray-200 text-gray-700 px-3 py-1 rounded-full text-sm font-semibold">
            Provider: {organization.ehr_provider.toUpperCase()}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default AdminHeader;